var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { staticClass: "pager" }, [
    _c(
      "ul",
      { staticClass: "pagination flex", staticStyle: { "list-style": "none" } },
      [
        _vm.pagination.current_page > 1
          ? _c("li", { staticClass: "pager__item--previous" }, [
              _c(
                "a",
                {
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.changePage(_vm.pagination.current_page - 1)
                    },
                  },
                },
                [_c("i", { staticClass: "prev icon-arrow-right" })]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.pagesNumber, function (page) {
          return _c(
            "li",
            {
              staticClass: "number",
              class: {
                "is-active": page == _vm.pagination.current_page,
                last: page === _vm.pagesNumber[_vm.pagesNumber.length - 1],
              },
            },
            [
              _c(
                "a",
                {
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.changePage(page)
                    },
                  },
                },
                [_vm._v(_vm._s(page))]
              ),
            ]
          )
        }),
        _vm._v(" "),
        _vm.pagination.current_page < _vm.pagination.last_page
          ? _c("li", { staticClass: "pager__item--next" }, [
              _c(
                "a",
                {
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.changePage(_vm.pagination.current_page + 1)
                    },
                  },
                },
                [_c("i", { staticClass: "next icon-arrow-right" })]
              ),
            ])
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }